import { MymeProgress } from '@myme/utils';
import i18n from 'i18next';

const getMymeProgressAsText = (progress: number) => {
  if (!progress) {
    return i18n.t('pages.library.myme_not_started');
  }
  if (progress === 100) {
    return i18n.t('pages.library.myme_finished');
  }

  return `${progress}%`;
};

export const getMymeProgress = (progress: number | undefined): MymeProgress => ({
  value: progress || 0,
  text: getMymeProgressAsText(progress || 0)
});
